<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-11 11:17:32
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-12-29 16:23:55
 * @Description: 取消开票
-->
<template>
  <el-form :model="input" :rules="rules" ref="input" label-width="90px">
    <el-form-item label="操作备注" prop="cancelRemark">
      <el-input
        maxlength="100"
        show-word-limit
        type="textarea"
        :rows="3"
        v-model="input.cancelRemark"
      ></el-input>
    </el-form-item>
    <el-form-item class="right">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      input: {
        cancelRemark: ''
      },
      rules: {
        cancelRemark: [
          { required: true, message: '请输入操作备注', trigger: 'blur' },
          { min: 4, max: 100, message: '最少输入4个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.input.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.input)
        }
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.right {
  text-align: right;
}
</style>
